import MoreVert from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React, { useCallback } from 'react'

import VacationHoldChip from 'components/common/chip/VacationHoldChip'

import type { SxProps, Theme } from '@mui/material/styles'
import type { VacationHoldApi } from 'types/api/account/vacationHold'

type Props = {
  hold: VacationHoldApi
  dateRange: string
  locationNames: string[]
  divider: boolean
  showActionMenu: boolean
  sx?: SxProps<Theme>
  onOpenActionMenu?: (event: React.MouseEvent<HTMLElement>, hold: VacationHoldApi) => void
}

const ROW_SX = { alignItems: 'flex-start', paddingBottom: 0 }
const LOCATION_SX = { mr: 4, ml: 2 }

const VacationHoldListItem: React.FC<Props> = ({ hold, dateRange, locationNames, divider, showActionMenu, sx, onOpenActionMenu }) => {
  const handleOpenActionMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => onOpenActionMenu?.(event, hold),
    [hold, onOpenActionMenu]
  )

  const locationCountLabel = `${locationNames.length} ${locationNames.length === 1 ? 'location' : 'locations'}`

  return (
    <ListItem divider={divider} sx={[ROW_SX, ...(Array.isArray(sx) ? sx : [sx])]}>
      <ListItemText
        disableTypography
        primary={<Typography variant="h6">{hold.title}</Typography>}
        secondary={
          <Stack>
            <Typography color="textSecondary">{locationCountLabel}</Typography>
            {locationNames.map(name => (
              <ListItem key={name} disableGutters disablePadding sx={LOCATION_SX}>
                <ListItemText primary={name} />
              </ListItem>
            ))}
          </Stack>
        }
      />
      <Stack alignItems="center" direction="row" flexWrap="nowrap" gap={1} sx={{ ml: 1 }}>
        <VacationHoldChip label={dateRange} type={hold.type} />
        {showActionMenu && (
          <IconButton onClick={handleOpenActionMenu}>
            <MoreVert />
          </IconButton>
        )}
      </Stack>
    </ListItem>
  )
}

export default VacationHoldListItem
